// assets/mobile-navigation.js

document.addEventListener('DOMContentLoaded', () => {
  const mobileNavItems = document.querySelectorAll('.mobile-nav__item');
  const currentPath = window.location.pathname;

  mobileNavItems.forEach(item => {
    const itemPath = item.getAttribute('href');
    if (currentPath.includes(itemPath) && itemPath !== '/') {
      item.classList.add('mobile-nav__item--active');
    } else if (currentPath === '/' && itemPath === '/') {
      item.classList.add('mobile-nav__item--active');
    }
  });
});